import React from "react";
import { useTranslation } from "react-i18next";
import ExerciseLibraryCoachComponent from "../../dashboard/settings/ExerciseLibraryCoachComponent";
import AdminToggle from "../components/AdminToggle";
import { useRillContext } from "../../../rill/RillReact/share/base";

const ExerciseLibrary = () => {
  useTranslation("admin");
  const { locals } = useRillContext();

  const {
    activeUser,
    query: { primary, type },
    exerciseCatalog,
  } = locals;

  return (
    <main className="admin">
      <AdminToggle />

      <ExerciseLibraryCoachComponent
        type={type}
        primary={primary}
        secondaries={exerciseCatalog}
        activeUser={activeUser}
        isAdminConsole
      />
    </main>
  );
};

export default ExerciseLibrary;
